import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme, type ThemePreference } from '../../lib/theme';
import { SegmentedControl, type SegmentOption } from './SegmentedControl';

const OPTIONS: SegmentOption<ThemePreference>[] = [
  { value: 'system', ariaLabel: 'System theme', icon: <Monitor size={14} aria-hidden /> },
  { value: 'light', ariaLabel: 'Light theme', icon: <Sun size={14} aria-hidden /> },
  { value: 'dark', ariaLabel: 'Dark theme', icon: <Moon size={14} aria-hidden /> },
];

export function ThemeSwitcher({ appearance = 'band' }: { appearance?: 'default' | 'band' }) {
  const [theme, setTheme] = useTheme();
  return <SegmentedControl options={OPTIONS} value={theme} onChange={setTheme} ariaLabel="Theme" appearance={appearance} size="sm" />;
}
